module.exports = __webpack_public_path__ + "img/about.99b8d720.png";